module.exports = "/images/risk-slideshow-1-v2.png?82f6a7972c5997d6964cb32f54d9dea3";